import { useEffect, useState } from "react";
import axios from "axios";
import { Eye } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = "gamya_visit_logged";

export default function VisitCounter() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let active = true;
    const run = async () => {
      try {
        const alreadyLogged = sessionStorage.getItem(SESSION_KEY) === "1";
        if (alreadyLogged) {
          const res = await axios.get(`${BACKEND_URL}/api/visits`);
          if (active) setCount(res.data.count);
        } else {
          const res = await axios.post(`${BACKEND_URL}/api/visits`);
          sessionStorage.setItem(SESSION_KEY, "1");
          if (active) setCount(res.data.count);
        }
      } catch {
        // Silent fail — counter is non-critical
      }
    };
    run();
    return () => {
      active = false;
    };
  }, []);

  if (count === null) return null;

  return (
    <div
      data-testid="visit-counter"
      className="inline-flex items-center gap-2 text-xs text-muted-foreground"
    >
      <Eye size={14} strokeWidth={1.75} className="text-accent" />
      <span className="tabular-nums">
        {Intl.NumberFormat().format(count)} visits
      </span>
    </div>
  );
}
